class AiSubectData {

    constructor(id, mainSubjectText, sonSubjectList = []) {
        this.id = id;
        this.subjectText = mainSubjectText;
        this.sonSubjectList = sonSubjectList;
    }

    getSubjectText() {
        return this.subjectText;
    }

    addSubject(data) {
        this.sonSubjectList.push(data);
    }

    getSubjectTextList() {
        return this.sonSubjectList;
    }

    getId() {
        return this.id;
    }

    getHeightChildCount() {        
        if (this.sonSubjectList.length > 0) {
            let count = 0
            for (let index = 0; index < this.sonSubjectList.length; index++) {
                let son = this.sonSubjectList[index]
                count += son.getHeightChildCount()
            }
            return count
        } else {
            return 1
        }
        
    }
}
export default AiSubectData